import cx from 'classnames'
import PropTypes from 'prop-types'

import Poly from '@s-ui/react-primitive-polymorphic-element'

import {LAYOUT_BASIC_CONTAINER_BASE_CLASS_NAME, MARGIN_TOP_SIZES, MAX_CONTENT_WIDTHS} from '../../settings.js'

const LayoutBasicContainer = ({
  as: Container = 'div',
  children,
  isFullHeight = false,
  isFullWidth = false,
  isMarginless = false,
  isMarginlessOnMobile = false,
  isPaddingless = false,
  marginTopSize = MARGIN_TOP_SIZES.MEDIUM,
  maxContentWidth = MAX_CONTENT_WIDTHS.MEDIUM
}) => {
  const className = cx(LAYOUT_BASIC_CONTAINER_BASE_CLASS_NAME, {
    [`${LAYOUT_BASIC_CONTAINER_BASE_CLASS_NAME}--fullHeight`]: isFullHeight,
    [`${LAYOUT_BASIC_CONTAINER_BASE_CLASS_NAME}--fullWidth`]: isFullWidth,
    [`${LAYOUT_BASIC_CONTAINER_BASE_CLASS_NAME}--marginless`]: isMarginless,
    [`${LAYOUT_BASIC_CONTAINER_BASE_CLASS_NAME}--marginlessOnMobile`]: isMarginlessOnMobile,
    [`${LAYOUT_BASIC_CONTAINER_BASE_CLASS_NAME}--marginTopSize-${marginTopSize}`]: marginTopSize,
    [`${LAYOUT_BASIC_CONTAINER_BASE_CLASS_NAME}--maxContentWidth-${maxContentWidth}`]: maxContentWidth,
    [`${LAYOUT_BASIC_CONTAINER_BASE_CLASS_NAME}--paddingless`]: isPaddingless
  })
  return (
    <Poly as={Container} className={className}>
      {children}
    </Poly>
  )
}

LayoutBasicContainer.displayName = 'LayoutBasicContainer'
LayoutBasicContainer.propTypes = {
  as: PropTypes.elementType,
  children: PropTypes.element,
  isFullHeight: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  isMarginless: PropTypes.bool,
  isMarginlessOnMobile: PropTypes.bool,
  isPaddingless: PropTypes.bool,
  marginTopSize: PropTypes.string,
  maxContentWidth: PropTypes.string
}

export default LayoutBasicContainer
